import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { FormGroupService } from './form-group.service';
import { FormControlDirective } from './form-control.directive';
import { FormControlLabelDirective } from './form-control-label.directive';
import { FormGroupDirective } from './form-group.directive';
import { DecimalsAutocompleteDirective } from './decimals-autocomplete.directive';
import { FormControlFilenameDirective } from './form-control-filename.directive';
import { FormControlDimensionDirective } from './form-control-dimension.directive';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DeleteCheckboxComponent } from './delete-checkbox/delete-checkbox.component';
import { SelectComponent } from './select/select.component';
import { DateInputComponent } from './date-input/date-input.component';
import { TextareaAutoResizeDirective } from './textarea-autoresize.directive';
import { SlideToggleComponent } from './slide-toggle/slide-toggle.component';
import { FormControlCharCounterComponent } from './form-control-char-counter/form-control-char-counter.component';
import { FromControlTrimDirective } from './form-control-trim.directive';


@NgModule({
  imports: [
    CommonModule,
    BsDatepickerModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    FormControlDirective,
    FormControlLabelDirective,
    FormGroupDirective,
    DecimalsAutocompleteDirective,
    FormControlDimensionDirective,
    FormControlFilenameDirective,
    CheckboxComponent,
    DeleteCheckboxComponent,
    SelectComponent,
    DateInputComponent,
    TextareaAutoResizeDirective,
    SlideToggleComponent,
    FormControlCharCounterComponent,
    FromControlTrimDirective,
  ],
  exports: [
    FormControlDirective,
    FormControlLabelDirective,
    FormGroupDirective,
    DecimalsAutocompleteDirective,
    FormControlDimensionDirective,
    FormControlFilenameDirective,
    CheckboxComponent,
    DeleteCheckboxComponent,
    SelectComponent,
    DateInputComponent,
    TextareaAutoResizeDirective,
    SlideToggleComponent,
    FormControlCharCounterComponent,
    FromControlTrimDirective,
   ],
  providers: [FormGroupService]
})
export class FormModule {}
